import request from '@/utils/request'
import VueCookies from 'vue-cookies'


// 登录接口
export function pwdLogin(data) {
  return request({
    url: '/userInfo/passwordLogin',
    method: 'post',
	data:data
  })
}


// 获取用户的相关协议
export function agreeInfo(data) {
  return request({
    url: '/agreement/getDetail',
    method: 'get',
	params:data
  })
}



// 发送验证码
export function smsCode(data) {
  return request({
    url: '/system/smsCode',
    method: 'post',
	data:data
  })
}



// 注册接口
export function register(data) {
  return request({
    url: '/userInfo/register',
    method: 'post',
	data:data
  })
}


// 获取图形验证码
export function getCaptchaCode() {
  return request({
    url: '/system/getCaptchaCode',
    method: 'get'
  })
}


// 忘记密码-校验图形验证码是否正确

export function checkCaptchaCode(data) {
  return request({
    url: '/userInfo/checkCaptchaCode',
    method: 'post',
	data:data
  })
}


// 忘记密码-校验用户名手机号是否正确

export function checkAccount(data) {
  return request({
    url: '/userInfo/checkAccount',
    method: 'post',
	data:data
  })
}
// 提交找回密码的信息

export function resetPassword(data) {
  return request({
    url: '/userInfo/resetPassword',
    method: 'post',
	data:data
  })
}